import i18n from '../../../i18n'

export function toContractSelectItem(item) {
  const additionalData = [
    item.user?.fullname,
    item.building?.address?.value,
    item.flat?.number
      ? `${i18n.t('Common.FlatSelectListItemNumberPrefixKey')} ${item.flat.number}`
      : null,
  ]
    .filter(Boolean)
    .join(' • ')

  return {
    ...item,
    additionalData,
    label: item.contract_id || i18n.t('Contract.NoContractIDKey'),
    value: item.id,
  }
}

export function toContractSelectItems(items, mapper = toContractSelectItem) {
  return items.map(mapper)
}
